import React from "react";
import "./landing.css";

const CHECKS = [
  "Sourced from growers we buy from directly, every day",
  "Graded and handled from the market floor to your crate",
  "Checked against our own standards before it is loaded",
  "Consistent from one delivery to the next",
];

export default function QualityAssured() {
  return (
    <section className="tfm-quality" id="qualityassured">
      <img
        className="tfm-quality__bg"
        src="/images/Banner9.png"
        alt=""
        aria-hidden="true"
        loading="lazy"
      />

      <div className="tfm-container">
        <div className="tfm-quality__inner">
          <p className="tfm-eyebrow">Quality assured</p>
          <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
            Produce your chef would have picked themselves.
          </h2>

          <div className="tfm-prose" style={{ marginTop: "1.5rem" }}>
            <p>
              Quality is the whole business. We source the freshest fruit and
              vegetables from growers we trust, and every item is handled with
              care from the market floor to your shelf. What reaches your
              kitchen is what we would put on our own.
            </p>
          </div>

          <ul className="tfm-quality__checks">
            {CHECKS.map((check) => (
              <li key={check}>
                <CheckIcon />
                <span>{check}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

function CheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="m4 12.5 5 5L20 6.5"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
